// Listado de inventarios (Dashboard)
import React, { useMemo } from 'react';
import { useAuth } from '../../context/AuthContext';

const style = `
@keyframes blinkRedInfinite {
  0%, 100% { background-color: #ffe5e5; }
  50% { background-color: #ffb3b3; }
}

.blink-red {
  animation: blinkRedInfinite 1.2s ease-in-out infinite;
}

.expired-row td {
  border-top: 1px solid #fecaca;
  border-bottom: 1px solid #fecaca;
  background-color: #fff5f5;
}
.expired-row td:first-child {
  border-left: 3px solid #ef4444;
}
.expired-row td:last-child {
  border-right: 1px solid #fecaca;
}
.blink-red.expired-row td {
  background-color: transparent;
}
`;

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

const getStatusLabel = (status) => {
  switch (status) {
    case 'pending':
      return 'Pendiente';
    case 'started':
      return 'Empezado';
    case 'completed':
      return 'Completado';
    case 'pendingvalidation':
      return 'Pendiente validación';
    default:
      return 'Sin determinar';
  }
};

const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'started':
      return 'bg-blue-100 text-blue-800';
    case 'completed':
      return 'bg-green-100 text-green-800';
    case 'pendingvalidation':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

const InventoryList = ({ inventories, onViewInventory }) => {
  const { user, roles } = useAuth();

  // console.log('=== DEBUG InventoryList ===');
  // console.log('User completo:', user);
  // console.log('Roles calculados:', roles);
  // console.log('roles.isManager:', roles.isManager);
  // console.log('roles.profileId:', roles.profileId);
  // console.log('Inventarios recibidos:', inventories);


  const sortedInventories = useMemo(() => {
    return [...inventories].sort((a, b) => {
      if (a.has_validation_required && !b.has_validation_required) return -1;
      if (!a.has_validation_required && b.has_validation_required) return 1;
      return 0;
    });
  }, [inventories]);

  const getRowHighlightClass = (inventory) => {
    // console.log('=== DEBUG getRowHighlightClass ===');
    // console.log('Inventory ID:', inventory.inventory_id);
    // console.log('has_validation_required:', inventory.has_validation_required);
    // console.log('typeof has_validation_required:', typeof inventory.has_validation_required);
    // console.log('roles.isManager:', roles.isManager);
    // console.log('Condición completa:', roles.isManager && inventory.has_validation_required === 1);

    const classes = [];
    if (roles.isManager && inventory.has_validation_required === 1) {
      classes.push('blink-red');
    }
    if (inventory.type === 'expired') {
      classes.push('expired-row');
    }
    return classes.join(' ');
  };

  const truncateName = (name) => {
    return name.length > 20 ? `${name.substring(0, 20)}...` : name;
  };

  return (
    <>
      <style>{style}</style>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-1 py-3 text-xs font-medium tracking-wider text-center text-gray-500 uppercase w-px">
                #
              </th>
              {roles.isAdmin && (
                <>
                <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                  Tienda
                </th>
                </>
              )}
              <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                Nombre
              </th>
              <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                Estado
              </th>
              {roles.isAdmin && (
                <>
                  <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Origen
                  </th>
                  <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Creado por
                  </th>
                  <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Fecha de creación
                  </th>
                  <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Fecha Inicio Inventario
                  </th>
                  <th className="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                    Fecha Fin Inventario
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {sortedInventories.map((inventory) => (
              <tr
                key={inventory.inventory_id}
                className={`hover:bg-gray-50 cursor-pointer ${getRowHighlightClass(inventory)}`}
                onClick={() => onViewInventory(inventory.inventory_id)}
              >
                <td className="px-1 py-2 whitespace-nowrap text-center w-px">
                  <div className="text-[0.6rem] text-gray-600 leading-none mb-px">{inventory.inventory_id}</div>
                  {inventory.type === 'expired' ? (
                    <span className="inline-flex text-[0.6rem] font-bold text-red-600 bg-red-100 px-1 py-0.5 rounded whitespace-nowrap leading-none">🗓️ CAD</span>
                  ) : (
                    <span className="inline-flex text-[0.6rem] font-bold text-blue-600 bg-blue-100 px-1 py-0.5 rounded whitespace-nowrap leading-none">📦 INV</span>
                  )}
                </td>
                {roles.isAdmin && (
                  <>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-500">{inventory.shop}</div>
                  </td>
                  </>
                )}
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900" title={inventory.inventory_name}>
                    🔍 {truncateName(inventory.inventory_name)}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(inventory.status)}`}>
                    {getStatusLabel(inventory.status)}
                  </span>
                </td>
                {roles.isAdmin && (
                  <>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-500">{inventory.origin}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-500">{inventory.username_created}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-500">{formatDate(inventory.created_at)}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-500">{formatDate(inventory.available_start_date)}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-500">{formatDate(inventory.available_end_date)}</div>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default InventoryList;
